import React from 'react'
import { Route } from 'react-router'
import getPath from '../shared/utils/getPath'
import RootContainer from './containers/Root'
import VersionsContainer from './containers/Versions'

const releaseRoutes = (
  <Route
    component={RootContainer}
    key="release-routes"
    path={getPath('backend', '/release')}
  >
    <Route
      path={getPath('backend', '/release/:type/:id/versions')}
      component={VersionsContainer}
    />
  </Route>
)

export default releaseRoutes



// WEBPACK FOOTER //
// ./src/release/routes.js